import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/baseData/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/baseData/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/baseData/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/baseData/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/baseData/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/baseData/delete/batch', {
    params: {
      ids
    }
  })
}
